import Suggestions from './Suggestions'

export default Suggestions
